import {
  createBatimentLayer,
  createCadastreLayer,
  createDefaultMap,
  createManualZoneLayer,
  createMarkerFeature,
  createMarkerLayer,
  createParcelleLayer,
  createTeFenuaLayer,
  formatArea,
  getBatimentFeatureInfo,
  getCadastreFeatureInfo
} from './te_fenua_lib';
import { Draw, Modify } from 'ol/interaction';
import Select from 'ol/interaction/Select';
import { GeoJSON } from 'ol/format';
import Geolocation from 'ol/Geolocation';
import Control from 'ol/control/Control';
// import { delegate } from '../../shared/utils';
import {
  createEmpty as olCreateEmpty,
  extend as olExtend,
  getCenter,
  isEmpty as olIsEmpty
} from 'ol/extent';

const MAPS = new WeakMap();
let MARKER_PATH = '';

function initializeTeFenuaMap(container) {
  const elements = container.querySelectorAll(
    '.te-fenua:not([data-initialized])'
  );

  elements.forEach((element) => {
    if (element.closest('.te-fenua[data-initialized]')) {
      // on ignore les cartes déjà initialisée
      return;
    }

    let map = displayMap(element);
    MAPS.set(element, map);
    element.setAttribute('data-initialized', 'true');
  });
}

// Initialise la carte TeFenua quand le DOM est prêt
async function initialize() {
  initializeTeFenuaMap(document);

  // delegate('change', '[data-te-fenua-place]', (event) => {
  //   let map = getMapFromAddress(event.target);
  //   if (map) {
  //     if (event.detail.extent) fitExtent(map, event.detail.extent);
  //     else if (event.detail.point) moveMapTo(map, event.detail.point);
  //     if (event.detail.point) {
  //       const marker = createMarkerFeature(event.detail.point);
  //       map.markerLayer.getSource().addFeature(marker);
  //     }
  //   }
  // });
}

function getInputFromMap(mapElement) {
  return mapElement.parentElement.querySelector('input.features');
}

// function getMapFromAddress(element) {
//   element = element.closest('.te-fenua');
//   return MAPS.get(element);
// }
//
// We load leaflet dynamically, ramda and freedraw and assign them to globals.
// Latest freedraw version build needs globals.
// async function loadOpenLayers(editable) {
//   await import('ol').then(ol => console.log(ol));
//   window.OL = await import('ol').then(OL => OL);
//
//   if (editable) {
//     window.R = await import('ramda').then(({ default: R }) => R);
//     await import('leaflet-freedraw/dist/leaflet-freedraw.web.js');
//   }
// }

// Les libellés viennent de la valeur du champ : on les insère comme du texte.
function createLink(feature) {
  const button = document.createElement('button');
  button.type = 'button';
  button.addEventListener('click', () => viewOnMap(button, feature.getId()));
  const img = document.createElement('img');
  img.alt = 'Voir sur la carte';
  img.src = MARKER_PATH;
  img.style.maxWidth = '1rem';
  img.style.height = 'auto';
  button.appendChild(img);
  return button;
}

function joinLabels(labels) {
  return labels.filter(Boolean).join(' - ');
}

function parcelleLabel(feature) {
  const p = feature.getProperties();
  const area = formatArea(feature.getGeometry());
  return joinLabels([p.label, p.commune_associee, area]);
}

function batimentLabel(feature) {
  const p = feature.getProperties();
  const area = formatArea(feature.getGeometry());
  return joinLabels([p.info_titre || p.nom || p.sous_categorie, area]);
}

function zoneLabel(feature) {
  const p = feature.getProperties();
  const area = formatArea(feature.getGeometry());
  const ca = p.commune_associee !== p.commune ? p.commune_associee : null;
  const cadastre = p.section + p.numero;
  return joinLabels([feature.getId(), area, cadastre, ca, p.commune, p.ile]);
}

function markerLabel(feature) {
  const p = feature.getProperties();
  const ca = p.commune_associee !== p.commune ? p.commune_associee : null;
  return joinLabels([
    feature.getId(),
    p.section + p.numero,
    ca,
    p.commune,
    p.ile
  ]);
}

function getMapFromLocationButton(element) {
  const mapElement = element.closest('.geo-areas').previousElementSibling;
  if (mapElement.getAttribute('class').includes('te-fenua'))
    return MAPS.get(mapElement);
  return undefined;
}

function viewOnMap(element, id) {
  let map = getMapFromLocationButton(element);
  let feature =
    map.batimentsLayer.getSource().getFeatureById(id) ||
    map.parcellesLayer.getSource().getFeatureById(id) ||
    map.markerLayer.getSource().getFeatureById(id) ||
    map.zoneManuellesLayer.getSource().getFeatureById(id);
  if (feature) fitExtent(map, feature.getGeometry().getExtent());
}

function appendAreas(container, layer, toLabel, title) {
  const features = layer.getSource().getFeatures();
  if (!features.length) return;
  const header = document.createElement('div');
  header.className = 'areas-title';
  header.textContent = title;
  const list = document.createElement('ul');
  features.forEach((feature) => {
    const item = document.createElement('li');
    item.append(createLink(feature), '\u00a0' + toLabel(feature));
    list.appendChild(item);
  });
  container.append(header, list);
}

function centerMapOnLocation(map) {
  const view = map.getView();
  let location = new Geolocation({
    projection: view.getProjection(),
    tracking: true
  });
  location.once('change', () => {
    view.animate({ center: location.getPosition() });
    location.setTracking(false);
  });
}

function centerMap(map) {
  let extent = olCreateEmpty();
  olExtend(extent, map.parcellesLayer.getSource().getExtent());
  olExtend(extent, map.batimentsLayer.getSource().getExtent());
  olExtend(extent, map.zoneManuellesLayer.getSource().getExtent());
  if (olIsEmpty(extent)) centerMapOnLocation(map);
  else fitExtent(map, extent);
}

// function moveMapTo(map, point) {
//   map.getView().animate({ center: point });
// }

function fitExtent(map, extent) {
  let view = map.getView();
  view.fit(extent, { duration: 2000, maxZoom: 17 });
}

function createControl(map, handler, action, tooltip = 'Bouton') {
  const button = document.createElement('button');
  button.setAttribute('title', tooltip);
  button.setAttribute('type', 'button');
  //button.innerHTML = icon;

  button.addEventListener('click', handler, false);

  const frame = document.createElement('div');
  frame.className = `ol-control-${action} ol-unselectable ol-control`;
  frame.appendChild(button);

  const control = new Control({
    element: frame
  });
  map.addControl(control);
}

function updateInformations(informations, map) {
  informations.replaceChildren();
  appendAreas(informations, map.parcellesLayer, parcelleLabel, 'Parcelles');
  appendAreas(informations, map.batimentsLayer, batimentLabel, 'Batiments');
  appendAreas(informations, map.markerLayer, markerLabel, 'Lieux');
  appendAreas(informations, map.zoneManuellesLayer, zoneLabel, 'Zones');
}

function initMap(mapElement, map) {
  function initFeatures(zoneSource, layer) {
    if (zoneSource) {
      const zones = new GeoJSON().readFeatures(zoneSource);
      zones.forEach((f) => layer.getSource().addFeature(f));
    }
  }

  let data = mapElement.getAttribute('data-geo');
  if (data == null) {
    const input = getInputFromMap(mapElement);
    if (input) data = input.value;
  }
  if (data) {
    // récupère la zone d'information des objets selectionnés.
    const informations = mapElement.parentElement.querySelector('.geo-areas');
    // Prépare l'interpréteur GEOJSON.
    const geodata = JSON.parse(data);

    initFeatures(geodata.parcelles, map.parcellesLayer);
    initFeatures(geodata.markers, map.markerLayer);
    initFeatures(geodata.batiments, map.batimentsLayer);
    initFeatures(geodata.zones_manuelles, map.zoneManuellesLayer);
    updateInformations(informations, map);
  }
}

// Fonction pour normaliser une clé
function normaliserCle(cle) {
  return cle
    .normalize('NFD') // décompose les accents
    .replace(/[\u0300-\u036f]/g, '') // supprime les accents
    .replace(/[^\w\s]/g, '') // supprime caractères spéciaux (sauf lettres, chiffres, _)
    .trim()
    .replace(/\s+/g, '_') // remplace les espaces par _
    .toLowerCase(); // met en minuscules
}

function toObject(texte) {
  return Object.fromEntries(
    texte
      .trim()
      .split('\n')
      .map((ligne) => {
        const [cle, ...valeurs] = ligne.split(':');
        const cleNormalisee = normaliserCle(cle);
        const valeur = valeurs.join(':').trim();
        return [cleNormalisee, valeur];
      })
  );
}

// add interaction on the map to select parcelles(cadastres), batiments & add manually zones to the map.
function addInteractions(mapElement, map) {
  // récupère la zone d'information des objets selectionnés.
  const informations = mapElement.parentElement.querySelector('.geo-areas');
  // Prépare l'interpréteur GEOJSON.
  const geojson = new GeoJSON();
  // Récupère la vue de carte.
  const mapView = map.getView();
  // champ à remplir avec les zones selectionnées
  let champ = getInputFromMap(mapElement);
  // valeur du champ
  let geodata = champ.value.length > 0 ? JSON.parse(champ.value) : {};
  // layer pour ajouter les zones manuelles
  let zoneManuellesLayer = map.zoneManuellesLayer;
  // entry types : parcelles, batiments, zone_manuelles ?
  // récupération du bouton pour supprimer le marqueur
  const removeMarkerButton = mapElement.querySelector('#remove-marker-button');
  if (removeMarkerButton) {
    removeMarkerButton.style.display = 'none';
  }
  const entry_type = mapElement.getAttribute('data-entry') || '';

  const add_zone = entry_type === 'zones_manuelles';
  const add_batiment = entry_type === 'batiments';
  const add_parcelle = entry_type === 'parcelles';
  const add_marker = !(add_zone || add_batiment || add_parcelle);
  // help bubbles
  const bubbles = {
    add: mapElement.querySelector('.add'),
    add_zone: mapElement.querySelector('.add-zone'),
    add_batiment: mapElement.querySelector('.batiment'),
    add_parcelle: mapElement.querySelector('.parcelle'),
    add_marker: mapElement.querySelector('.marker')
  };

  hideHelps();
  let draw, select, modify;

  if (add_zone || add_marker) {
    createControl(
      map,
      clickOnToggleCadastre,
      'layers',
      'Afficher/masquer le cadastre'
    );
  }

  function extractProperties(f, feature) {
    const p = toObject(f.getProperties().info_texte);
    feature.setProperties({
      commune: p.commune,
      commune_associee: p.commune_associee,
      ile: p.ile,
      section: p.section,
      numero: p.numero
    });
  }

  function addFeatureToChamp(layer, feature, field, category) {
    const source = layer.getSource();
    let index = 1; // source.getFeatures().length + 1;
    let id;
    while (source.getFeatureById((id = `${category} ${index}`)) != null)
      index++;
    feature.setId(id);
    const coord = getCenter(feature.getGeometry().getExtent());
    let resolution = mapView.getResolution();
    let projection = mapView.getProjection();
    getCadastreFeatureInfo(coord, resolution, projection).then((pjson) => {
      if (!pjson || pjson.type !== 'FeatureCollection') {
        throw new Error('Invalid response returned');
      }
      // ajoute le nom de la commune et l'il à la zone créé
      const features = geojson.readFeatures(pjson);
      if (features.length) {
        extractProperties(features[0], feature);
      }
      setTimeout(() => updateChampWith(field, layer));
    });
  }

  if (add_zone) {
    bubbles.add.style.display = 'block';
    draw = new Draw({
      source: zoneManuellesLayer.getSource(),
      type: 'Polygon'
    });
    map.addInteraction(draw);
    draw.setActive(false);
    modify = new Modify({ source: zoneManuellesLayer.getSource() });
    map.addInteraction(modify);
    select = new Select({ layers: [zoneManuellesLayer] });
    map.addInteraction(select);
    createControl(map, clickOnEffaceZone, 'delete', 'Effacer une zone');
    createControl(map, clickOnAddZone, 'add', 'Ajouter une zone');
    draw.on('drawend', (e) => {
      bubbles.add_zone.style.display = 'none';
      const layer = map.zoneManuellesLayer;
      addFeatureToChamp(layer, e.feature, 'zones_manuelles', 'Zone');
      // fin de dessin d'une zone ==> désactive l'ajout d'autres zones
      draw.setActive(false);
      // activate lookForBatimentsAndParcelles in a timeout so it doesn't get triggered
      // by the current click
      if (add_parcelle || add_batiment)
        setTimeout(() => addBatimentParcelleInteraction());
    });
  }

  if (add_parcelle || add_batiment) {
    createControl(
      map,
      clickOnEffaceParcelleBatiment,
      'delete',
      add_parcelle
        ? 'Effacer les parcelles sélectionnées'
        : 'Effacer les bâtiments sélectionnés'
    );
  } else if (add_marker) {
    createControl(
      map,
      clickOnEffaceMarqueur,
      'delete',
      'Effacer tous les marqueurs'
    );
  }

  createControl(map, clickOnGeolocate, 'geolocate', 'Me localiser');

  addBatimentParcelleInteraction();

  if (removeMarkerButton) {
    removeMarkerButton.addEventListener('click', () => {
      map.markerLayer.getSource().clear();
      delete geodata.position;
      champ.value = JSON.stringify(geodata);
      champ.dispatchEvent(new Event('change', { bubbles: true }));
      removeMarkerButton.style.display = 'none';
    });
  }

  const addMarkerButton = mapElement.querySelector('#add-marker-button');
  if (add_marker) {
    let markerMode = false;

    const onMarkerClick = (evt) => {
      const featureAtPixel = map.forEachFeatureAtPixel(
        evt.pixel,
        (feature) => feature,
        {
          layerFilter: (layer) => layer === map.markerLayer,
          hitTolerance: 8
        }
      );

      if (featureAtPixel) {
        map.markerLayer.getSource().removeFeature(featureAtPixel);
        updateChampWith('markers', map.markerLayer);
      } else {
        const feature = createMarkerFeature(evt.coordinate, MARKER_PATH);
        map.markerLayer.getSource().addFeature(feature);
        addFeatureToChamp(map.markerLayer, feature, 'markers', 'Marqueur');
      }
    };

    const isMarkerOnlyMode = !add_parcelle && !add_batiment && !add_zone;

    if (isMarkerOnlyMode) {
      markerMode = true;
      map.on('click', onMarkerClick);

      if (addMarkerButton) {
        addMarkerButton.style.display = 'none';
      }
    } else if (addMarkerButton) {
      addMarkerButton.addEventListener('click', () => {
        markerMode = !markerMode;
        addMarkerButton.classList.toggle('active', markerMode);

        if (markerMode) {
          addMarkerButton.textContent = 'Marqueur actif';
          map.on('click', onMarkerClick);
          map.un('click', lookForBatimentsAndParcelles);
        } else {
          addMarkerButton.textContent = 'Placer un marqueur';
          map.un('click', onMarkerClick);
          if (add_parcelle || add_batiment) {
            map.on('click', lookForBatimentsAndParcelles);
          }
        }
      });
    }

    if (geodata.positions) {
      geodata.positions.forEach((pos) => {
        const coords = pos.geometry.coordinates;
        const marker = createMarkerFeature(coords, MARKER_PATH);
        map.markerLayer.getSource().addFeature(marker);
      });
    }
  }

  if (removeMarkerButton) {
    removeMarkerButton.style.display = 'none';
  }

  function hideHelps() {
    Object.keys(bubbles).forEach((b) => (bubbles[b].style.display = 'none'));
  }

  function addBatimentParcelleInteraction() {
    if (add_parcelle || add_batiment)
      map.on('click', lookForBatimentsAndParcelles);
    if (add_parcelle) bubbles.add_parcelle.style.display = 'block';
    if (add_batiment) bubbles.add_batiment.style.display = 'block';
    if (add_marker) bubbles.add_marker.style.display = 'block';
  }

  function clickOnAddZone(e) {
    // bouton ajout d'une zone cliqué
    e.preventDefault();
    // désactivation de la selection de parcelles/batiment
    map.un('click', lookForBatimentsAndParcelles);
    // activation de l'interaction d'ajout de zone manuelle
    draw.setActive(true);
    // désactive l'aide du bouton et affiche l'aide de tracé de zone
    hideHelps();
    bubbles.add_zone.style.display = 'block';
  }

  function clickOnEffaceZone(e) {
    e.preventDefault();
    if (select.getFeatures().getLength() > 0) {
      // area are already selected ==> delete them
      deleteSelectedZones();
    } else {
      // no area selected => next selected object will be deleted
      select.once('select', () => {
        deleteSelectedZones();
      });
    }
  }

  function clickOnEffaceParcelleBatiment(e) {
    e.preventDefault();
    if (add_parcelle) {
      map.parcellesLayer.getSource().clear();
      updateChampWith('parcelles', map.parcellesLayer);
    } else if (add_batiment) {
      map.batimentsLayer.getSource().clear();
      updateChampWith('batiments', map.batimentsLayer);
    }
  }

  function clickOnEffaceMarqueur(e) {
    e.preventDefault();
    map.markerLayer.getSource().clear();
    updateChampWith('markers', map.markerLayer);
  }

  function clickOnToggleCadastre(e) {
    e.preventDefault();
    map.cadastreLayer.setVisible(!map.cadastreLayer.getVisible());
  }

  function clickOnGeolocate(e) {
    e.preventDefault();

    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = [position.coords.longitude, position.coords.latitude];
          map.getView().animate({ center: coords, zoom: 18 });
        },
        (error) => {
          alert('Impossible d’obtenir votre position.');
          console.error(error);
        },
        { enableHighAccuracy: true }
      );
    } else {
      alert('Votre navigateur ne prend pas en charge la géolocalisation.');
    }
  }

  function deleteSelectedZones() {
    select
      .getFeatures()
      .forEach((f) => zoneManuellesLayer.getSource().removeFeature(f));
    select.getFeatures().clear();
    updateChampWith('zones_manuelles', zoneManuellesLayer);
  }

  function updateChampWith(attribute, layer) {
    geodata[attribute] = geojson.writeFeaturesObject(
      layer.getSource().getFeatures()
    );
    champ.value = JSON.stringify(geodata);
    const event = new Event('change', { bubbles: true });
    champ.dispatchEvent(event);
    updateInformations(informations, map);
  }

  function addRemoveFeatures(features, layer, attribute, areEquals) {
    features.forEach((f) => {
      //let selected = parcelleLayer.getSource().getFeatureById(f.getId());
      let source = layer.getSource();
      let selected = source
        .getFeatures()
        .find((ft) => areEquals(ft.getProperties(), f.getProperties()));
      if (selected) {
        source.removeFeature(selected);
      } else {
        source.addFeature(f);
      }
    });
    updateChampWith(attribute, layer);
  }

  // look for parcelles under the cursor, and select/unselect according already selected parcelles
  function lookForParcelles(coord, resolution, projection) {
    // const start = new Date();
    getCadastreFeatureInfo(coord, resolution, projection).then((pjson) => {
      // const time = new Date(new Date() - start).getMilliseconds();
      // console.info(`get parcelles time = ${time}`);
      if (!pjson || pjson.type !== 'FeatureCollection') {
        throw new Error('Invalid response returned');
      }
      // Ajoute/Supprime sur la carte les parcelles trouvées par Te Fenua
      const features = geojson.readFeatures(pjson);
      features.forEach((f) => extractProperties(f, f));
      const areEquals = (a, b) => {
        const getParcelleId = (props) => {
          if (props.id) return props.id.toString();
          if (props.label) return props.label;
          return `${props.ile || ''}-${props.commune || ''}-${props.section || ''}-${props.numero || ''}`;
        };
        return getParcelleId(a) === getParcelleId(b);
      };
      if (features.length) {
        addRemoveFeatures(features, map.parcellesLayer, 'parcelles', areEquals);
      }
    });
  }

  // look for batiments under the cursor and if not found look for parcelle
  function lookForBatiments(coord, resolution, projection) {
    // const start = new Date();
    getBatimentFeatureInfo(coord, resolution, projection).then((json) => {
      // const time = new Date(new Date() - start).getMilliseconds();
      // console.info(`get batiments time = ${time}`);
      if (!json || json.type !== 'FeatureCollection') {
        throw new Error('Invalid response returned');
      }
      const features = geojson.readFeatures(json);
      const batimentEquals = (a, b) => {
        const getBatimentId = (props) =>
          `${props.ile}-${props.commune}-${props.section}-${props.numero || props.id}`;
        return getBatimentId(a) === getBatimentId(b);
      };
      if (features.length) {
        // Ajoute/Supprime sur la carte les batiments trouvées par Te Fenua
        addRemoveFeatures(
          features,
          map.batimentsLayer,
          'batiments',
          batimentEquals
        );
      } else if (add_parcelle) {
        // pas de batiment trouvé ==> recherche les parcelles au point cliqué
        lookForParcelles(coord, resolution, projection);
      }
    });
  }

  function lookForBatimentsAndParcelles(ev) {
    // Récupère les batiments cliquées.
    let coord = ev.coordinate;
    let resolution = mapView.getResolution();
    let projection = mapView.getProjection();
    if (add_marker && !add_parcelle && !add_batiment) {
      return;
    }
    if (add_batiment) {
      lookForBatiments(coord, resolution, projection);
    } else if (add_parcelle) {
      lookForParcelles(coord, resolution, projection);
    }
  }
}

function displayMap(mapElement) {
  MARKER_PATH = mapElement.getAttribute('data-marker');

  // Prépare les couches
  const parcellesLayer = createParcelleLayer();
  const batimentsLayer = createBatimentLayer();
  const zoneManuellesLayer = createManualZoneLayer();
  const markerLayer = createMarkerLayer();
  const cadastreLayer = createCadastreLayer();

  // Prépare la carte OpenLayers.
  let map = createDefaultMap(mapElement, [
    createTeFenuaLayer(),
    cadastreLayer,
    parcellesLayer,
    batimentsLayer,
    zoneManuellesLayer,
    markerLayer
  ]);
  map.parcellesLayer = parcellesLayer;
  map.cadastreLayer = cadastreLayer;
  map.batimentsLayer = batimentsLayer;
  map.zoneManuellesLayer = zoneManuellesLayer;
  map.markerLayer = markerLayer;

  initMap(mapElement, map);

  centerMap(map);

  if (getInputFromMap(mapElement)) addInteractions(mapElement, map);

  return map;
}

// Écouteur générique pour mutations du DOM (attrape les cas non gérés par Turbo)
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList && node.classList.contains('te-fenua')) {
              let map = displayMap(node, true);
              MAPS.set(node, map);
              node.setAttribute('data-initialized', 'true');
            }

            // Vérifier aussi les sous-éléments
            if (node.querySelectorAll) {
              initializeTeFenuaMap(node);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

addEventListener('DOMContentLoaded', initialize);

/*
addEventListener('carte:update', ({ detail: { selector, data } }) => {
  const element = document.querySelector(selector);
  diplayMap(element, data);
});
*/
